import delv from 'dlv';

import { useAuthContext } from 'state/auth';
import { usePaymentContext } from 'state/payment';
import {
  CardTypes,
  IApplePayDetails,
  IGooglePayDetails,
  IPaymentMethod,
} from 'state/payment/types';
import { getCountryAndCurrencyCodes } from 'utils/form/constants';

const useReloadTimCard = () => {
  const {
    paymentMethods,
    reloadPrepaidCard,
    prepaidReloadPaymentMethodId: reloadPaymentMethodId,
  } = usePaymentContext();
  const { user } = useAuthContext();
  const billingCountry = delv(user!, 'details.isoCountryCode');
  const { countryCode, currencyCode } = getCountryAndCurrencyCodes(billingCountry);

  const reloadGiftCard = async (
    reloadAmount: number,
    balance: number,
    input?: IApplePayDetails | IGooglePayDetails
  ) => {
    const giftCard = paymentMethods.find((method: IPaymentMethod) => !!method.prepaid);
    const paymentCard = paymentMethods.find(
      (method: IPaymentMethod) => method.fdAccountId === reloadPaymentMethodId
    );
    const prepaidFdAccountId = giftCard?.fdAccountId ?? null;
    const cardType = paymentCard?.credit?.cardType ?? null;

    const ccReloadDetails = {
      fdAccountId: reloadPaymentMethodId,
    };

    let args = {
      fundValue: reloadAmount,
      fdAccountId: reloadPaymentMethodId,
      prepaidBalance: balance,
      countryCode,
      currencyCode,
      cardType,
      ...(prepaidFdAccountId && { prepaidFdAccountId }),
    };

    switch (reloadPaymentMethodId) {
      case CardTypes.APPLE_PAY:
        args = { ...args, ...{ applePayDetails: input } };
        break;
      case CardTypes.GOOGLE_PAY:
        args = { ...args, ...{ googlePayDetails: input } };
        break;
      default:
        args = { ...args, ...ccReloadDetails };
    }

    return reloadPrepaidCard(args);
  };

  return {
    reloadGiftCard,
  };
};

export default useReloadTimCard;
